import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner-desktop.component.html',
  styleUrls: ['./banner-desktop.component.scss'],
})
export class BannerDesktopComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
